import type { MenuLinkItemProps } from '@base-ui/react';
import type { ComponentPropsWithRef } from 'react';

import { Menu as BaseMenu } from '@base-ui/react';

import { clsx } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { itemStyle, menuItemIconStyle } from './Menu.css';

export type Props = ComponentPropsWithRef<'a'> &
  Pick<MenuLinkItemProps, 'label' | 'closeOnClick' | 'className'> & {
    icon?: IconName;
  };

export const MenuExternalLinkItem = ({ children, className, closeOnClick, icon, label, ...delegated }: Props) => {
  return (
    <BaseMenu.LinkItem
      className={clsx(itemStyle, className)}
      closeOnClick={closeOnClick ?? true}
      label={label}
      render={<a {...delegated} rel={delegated.rel ?? 'noreferrer'} target={delegated.target ?? '_blank'} />}
    >
      {icon && <Icon className={menuItemIconStyle} name={icon} size={22} />}

      <span>{children}</span>
    </BaseMenu.LinkItem>
  );
};
